import React, {useEffect, useState} from 'react';
import {Dashboard, Loader} from "../../components";
import * as actions from "../../store/actions";
import {connect} from "react-redux";

function Index(props) {
  const [servicesList, setServicesList] = useState([]);
  const [reportYear, setReportYear] = useState('')
 
  let {dashboardReducer: {dashboard, loading, error}} = props;

  useEffect(() => {

    props.getDashboardStart({year:reportYear});

  }, [reportYear]);

  // fetch services list
  useEffect(() => {
    setReportYear(new Date().getFullYear());
    props.getServicesList({pageNo: 1, pageSize: 100})
  }, []);
  useEffect(() => {
    if (props.servicesReducer?.error) {
    } else {
      let list = props?.servicesReducer?.servicesList?.resp || []
      // let len = list && list.length || 0;
      const references = []
      // for (let i = 0; i < len; i++) {
      //   references.push({text, value})
      // }
      setServicesList(list)
      // setState((prevState => ({
      //   ...prevState,
      //   servicesList: references,
      // })))
    }
  }, [props.servicesReducer?.servicesList, props.servicesReducer?.error]);

  return (
    <div className='mb-20'>
      {(loading || !servicesList) ? <Loader/> :
        servicesList.length > 0 &&
        <Dashboard reportYear={reportYear} setReportYear={setReportYear} dashboard={dashboard}
                   servicesList={servicesList} loading={loading} {...props}/>
      }
    </div>
  );
}


const mapStateToProps = ({dashboardReducer = {}, servicesReducer = {}}) => {
  return {dashboardReducer, servicesReducer};
};
const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardStart: (data) => dispatch(actions.dashboardStart(data)),
    messageHandler: (data) => dispatch(actions.labelsMessageHandler(data)),
    confirmationHandler: (data) => dispatch(actions.confirmationHandler(data)),
    getServicesList: (data) => dispatch(actions.getServicesList(data)),
    serviceReportMessageHandler: (data) => dispatch(actions.serviceReportMessageHandler(data)),

    setUserServicesList: (data) => dispatch(actions.setUserServicesList(data)),
    setCategoryList: (data) => dispatch(actions.setCategoryList(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
